import autoflowReducer from "./views/products/cap-ai/cap-automation/autoflowSlice";
import datasetScoringReducer from "./views/datasetScoring/DatasetScoringSlice";
import { configureStore } from "@reduxjs/toolkit";

export default configureStore({
  reducer: {
    autoflow: autoflowReducer,
    datasetScoring: datasetScoringReducer,
  },
});
